import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CompanyTypeView } from '@app/services/http/clients/api-proxies';
import { CompanyTypeService } from '@app/services/http/clients/company-type.service';
import { GenericDropdownComponent } from 'ngx-lib';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';

@Component({
    selector: 'app-company-type-form-editor',
    templateUrl: './company-type-form-editor.component.html',
    styleUrl: './company-type-form-editor.component.scss',
    providers: [createValueAccessorProvider(CompanyTypeFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class CompanyTypeFormEditorComponent extends FormEditorBase<CompanyTypeView[]> implements OnInit {
    // Inputs for direct signal usage
    value = input<CompanyTypeView[]>();
    readonly = input<boolean>();
    placeholderText = input<string>('Select Type');

    private readonly companyTypeService = inject(CompanyTypeService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadCompanyTypes();
    }

    onSelectedItemChange(selectedItem: any): void {
        if (selectedItem && selectedItem !== null) {
            this.selectedItems.set([selectedItem]);
        } else {
            this.selectedItems.set([]);
        }
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): CompanyTypeView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: CompanyTypeView[]): any[] {
        return value || [];
    }

    private async loadCompanyTypes(): Promise<void> {
        const items = await this.companyTypeService.getAll();
        this.items.set(items);
    }
}
